import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"
import HeadingSectionHeader from "src/components/Heading/HeadingSectionHeader"

const AutopaySection = ({ workOrder, onManage }) => {
  if (!workOrder.serviceBillingEnabled) return null

  const { autopayEnabled, autopayPaymentMethod, canUpdateAutopay } = workOrder

  let icon
  let title
  let description

  if (!autopayEnabled) {
    icon = "icon-pause"
    title = "AutoPay disabled"
    description = "Invoices on this work order will require manual collection."
  } else if (autopayPaymentMethod) {
    icon = "icon-credit-card"
    title = autopayPaymentMethod.title
    description = autopayPaymentMethod.subtitle
  } else {
    icon = "icon-credit-card"
    title = "No payment method selected"
    description = "Add a payment method to charge invoices automatically."
  }

  return (
    <div className="mt-6 rounded-lg border p-5">
      <div className="mb-3 flex items-center justify-between">
        <HeadingSectionHeader>AutoPay</HeadingSectionHeader>
        {canUpdateAutopay && (
          <Button
            variant="secondary"
            small
            icon="icon-edit-square-md"
            onClick={onManage}
          >
            Manage AutoPay
          </Button>
        )}
      </div>

      <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-4">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-500">
          <i className={`icon ${icon}`} />
        </span>
        <div>
          <div className="font-semibold">{title}</div>
          {description && (
            <div className="text-sm text-gray-500">{description}</div>
          )}
        </div>
      </div>
    </div>
  )
}

AutopaySection.propTypes = {
  workOrder: PropTypes.shape({
    serviceBillingEnabled: PropTypes.bool,
    canUpdateAutopay: PropTypes.bool,
    autopayEnabled: PropTypes.bool,
    autopayPaymentMethod: PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
    }),
  }).isRequired,
  onManage: PropTypes.func.isRequired,
}

export default AutopaySection
